import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Typography } from "@mui/material";
import NotificationsIcon from '@mui/icons-material/Notifications';
import theme from "../../theme";
import { useDispatch } from "react-redux";
import { getMileStoneTest } from "../../api/studentPerformanceApi";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import moment from "moment";

const UpcomingMilestone = () => {
    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    const getTestData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getMileStoneTest();
            setData(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getTestData();
    }, []);

    return (
        <Fragment>
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>Upcoming Tests/Tasks/Milestones</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>Pending actions within next week</Typography>
                            </Box>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Fragment>
                        <Box
                            sx={{
                                height: '30vh',
                                overflow: 'auto'
                            }}
                        >
                            {data?.length > 0 && data?.map((a, index) => (
                                <CommonCard
                                    key={index}
                                    paddingBottom="0px"
                                    borderRadius={2}
                                    marginTop={index === 0 ? "0px" : 1}
                                    background="#FAFAFA"
                                    content={
                                        <Box display="flex" justifyContent="space-between">
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <NotificationsIcon sx={{ color: theme.palette.background.dark, fontSize: 25 }} />
                                                <Box>
                                                    <Typography fontSize={15} fontWeight={600}>{a.title}</Typography>
                                                    <Typography fontSize={13} color={theme.palette.background.dark}>{a?.critical ? `Critical path for ${moment(a?.dueDate)?.format('MMM DD')}` : `${moment(a?.dueDate)?.format('MMM DD')} Completion`}</Typography>
                                                </Box>
                                            </Box>
                                            <Box
                                                sx={{
                                                    background: '#FEF9C2',
                                                    padding: '4px 10px',
                                                    marginBottom: 0.5,
                                                    borderRadius: 1,
                                                    height: '30px',
                                                    border: `1px solid #7A869126`
                                                }}
                                            >
                                                {moment(a?.dueDate).isBefore(moment()) ? (
                                                    <Typography fontSize={13} color={theme.palette.primary.main}>
                                                        Due {moment(a?.dueDate).toNow()}
                                                    </Typography>
                                                ) : (
                                                    <Typography fontSize={13} color={theme.palette.primary.main}>
                                                        Due {moment(a?.dueDate).format('MMM DD, YYYY')}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    }
                                />
                            ))}
                        </Box>
                    </Fragment>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default UpcomingMilestone;